export function stripHtmlToText(htmlString: string) {
    const parser: DOMParser = new DOMParser();
    const doc: Document = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
}
